<template>
    <PopupRouterViewDetail label="Surat Jalan Delivery Subcon Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Surat Jalan" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Nomor Surat Jalan" :model="model.suratJalanNumber" />
						<app-input-combobox-autocomplete :options="deliveryInstructionSubcontracts" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction-subcon" size="sm" :model.sync="model.deliveryInstructionSubconId" :isRequired="true" :state="validateState('deliveryInstructionSubconId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionSubconId, 'deliveryInstructionSubconId')"   :selected="model.deliveryInstructionSubcon != null ? model.deliveryInstructionSubcon.diNumber : ''" @input="getDeliveryInstructionSubcontracts" @change="updateData" :isEditable="false" :isUpdatable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstructionSubcon" />
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="false"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" />
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Destination" id="fieldset-destination" size="sm" :model.sync="model.destinationId"   :selected="model.destination != null ? model.destination.code : ''" @input="getCustomers" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDestination" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="true"/>
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Driver Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-driver-name" label-cols-lg="12"  label="Driver Name" label-for="input-driver-name" size="sm" :model.sync="model.driverName"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-vehicle-number" label-cols-lg="12"  label="Vehicle Number" label-for="input-vehicle-number" size="sm" :model.sync="model.vehicleNumber"  @change="updateData" :isUpdatable ="true"/>
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="List Part to Delivery" :bordered="true" :items="suratJalanDeliverySubconDetails" :fields="fieldsSuratJalanDeliverySubconDetail" :busy="isDataLoading" :sort-by.sync="sortBySuratJalanDeliverySubconDetail" :sort-desc.sync="sortDescSuratJalanDeliverySubconDetail" small responsive
			@editButtonMethod="editRowDataSuratJalanDeliverySubconDetail"
			@deleteButtonMethod="deleteRowDataSuratJalanDeliverySubconDetail"
			@showPopupAddMethod="resetDataSuratJalanDeliverySubconDetail()"
			@showPopupUploadMethod="showPopupUploadSuratJalanDeliverySubconDetail()"
			@downloadMethod="downloadSuratJalanDeliverySubconDetail()"
			@addFromClipboardMethod="addFromClipboardSuratJalanDeliverySubconDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardSuratJalanDeliverySubconDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadSuratJalanDeliverySubconDetail"
			>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( suratJalanDeliverySubconDetailPageSize * (currentSuratJalanDeliverySubconDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-surat-jalan-delivery-subcon-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false" :isUpdatable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(orderQty)="row">
				<app-input-textbox :id="'input-surat-jalan-delivery-subcon-detail-order-qty-' + row.index" label-cols-lg="12" label="Order Qty" size="sm" :model.sync="row.item.orderQty"   @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :isEditable="false" :isUpdatable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(stockVendorQty)="row">
				<app-input-textbox :id="'input-surat-jalan-delivery-subcon-detail-stock-vendor-qty-' + row.index" label-cols-lg="12" label="Stock Vendor Qty" size="sm" :model.sync="row.item.stockVendorQty" @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :isEditable="false" :isUpdatable ="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryQty)="row">
				<app-input-textbox :id="'input-surat-jalan-delivery-subcon-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :isUpdatable="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(printDc)="row">
				<b-overlay
					v-if="(row.item.deliveryQty > 0)"
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
				<b-button size="sm" variant="secondary" class="float-right btn-outline-success" @click="printDc(row.item)">Print DC</b-button>
				</b-overlay>
			</template>

			<template v-slot:form-add-detail>
				<SuratJalanDeliverySubconDetailInput 
					:openPopup="isShowPopupSuratJalanDeliverySubconDetail"
					:modelId="suratJalanDeliverySubconDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataSuratJalanDeliverySubconDetail"/>
			</template>
			<template v-slot:upload-detail>
				<SuratJalanDeliverySubconDetailUpload
					:openPopup="isShowPopupUploadSuratJalanDeliverySubconDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataSuratJalanDeliverySubconDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
					<app-input-textbox :id="'input-surat-jalan-delivery-subcon-detail-order-qty-' + row.index" label-cols-lg="12" label="Order Qty" size="sm" :model.sync="row.item.orderQty"   @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-surat-jalan-delivery-subcon-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputSuratJalanDeliverySubconDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>

		<template #modal-left-button>
			<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
			<b-button size="sm" variant="secondary" class="float-right btn-outline-success" @click="printSuratJalan()">Print Surat Jalan</b-button>
       		</b-overlay>
		</template>

		<PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Surat Jalan (Preview)" />
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SuratJalanDeliverySubcon from '@/models/SuratJalanDeliverySubcon/SuratJalanDeliverySubcon';
import SuratJalanDeliverySubconList from '@/models/SuratJalanDeliverySubcon/SuratJalanDeliverySubconList';
import SuratJalanDeliverySubconFilter from '@/filters/SuratJalanDeliverySubcon/SuratJalanDeliverySubconFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstructionSubcontract from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontract';
import DeliveryInstructionSubcontractFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import SuratJalanDeliverySubconDetail from '@/models/SuratJalanDeliverySubcon/SuratJalanDeliverySubconDetail';
import SuratJalanDeliverySubconDetailFilter from '@/filters/SuratJalanDeliverySubcon/SuratJalanDeliverySubconDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import DeliveryInstructionSubcontractDetail from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetail';
import DeliveryInstructionSubcontractDetailFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import SuratJalanDeliverySubconDetailInput from '@/views/SuratJalanDeliverySubcon/SuratJalanDeliverySubconDetailInput';
import SuratJalanDeliverySubconDetailUpload from '@/views/SuratJalanDeliverySubcon/SuratJalanDeliverySubconDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';

export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		SuratJalanDeliverySubconDetailInput,SuratJalanDeliverySubconDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF
	},
	mixins : [validationMixin],
	validations: {
		model: {
			deliveryInstructionSubconId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				deliveryInstructionSubconId: { required : "Delivery Instruction is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsSuratJalanDeliverySubconDetail: [
				{"printDc": {"class": "th-number d-stack-none", "label": "", key: 'printDc', sortable: false}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"orderQty": { "class" : "th-order-qty last-child", "label" : "Order Qty", key: 'orderQty', sortable: false}}, 
				{"stockVendorQty": { "class" : "th-stock-vendor-qty last-child", "label" : "Stock Vendor Qty", key: 'stockVendorQty', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelSuratJalanDeliverySubconDetail : {},
			isShowPopupSuratJalanDeliverySubconDetail : false,
			isShowPopupUploadSuratJalanDeliverySubconDetail : false,
			filterSuratJalanDeliverySubcon : null,
			currentSuratJalanDeliverySubconPage : 1,
			suratJalanDeliverySubconPageSize: 10,
			sortBySuratJalanDeliverySubcon: '',
			sortDescSuratJalanDeliverySubcon: '',
			filterSuratJalanDeliverySubconDetail : null,
			currentSuratJalanDeliverySubconDetailPage : 1,
			suratJalanDeliverySubconDetailPageSize: 10,
			sortBySuratJalanDeliverySubconDetail: '',
			sortDescSuratJalanDeliverySubconDetail: '',
			sortingBySuratJalanDeliverySubconDetail: [],
			suratJalanDeliverySubconDetails : [],
			suratJalanDeliverySubconDetailId : '',
			totalSuratJalanDeliverySubconDetailRow : 0,
			isShowSuratJalanDeliverySubconDetailFilter: false,
			isDownloadSuratJalanDeliverySubconDetail: false,
			parts: [],
			deliveryInstructionSubcontracts: [],
			deliveryInstructionSubcons: [],
			isDeliveryInstructionSubconComboLoading: false,
			customers: [],
			isCustomerComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryInstructionSubcontractComboLoading: false,
			isSuratJalanDeliverySubconComboLoading: false,
			isPartComboLoading: false,
			isDeliveryInstructionSubcontractDetailComboLoading: false,
			isShowPopupPDF: false,
			pdfUrl: '',
		}
	},
	methods : {
		async printDc(item) {
			let this_ = this;
			this_.isBusy = true;

			const response = await this_.$http.get(`SuratJalanDeliverySubcon/printdc/${item.id}`);
			console.log("pdf url", response);
			this_.showPopupPDF(response.data.download);
			this_.isBusy = false;

			// return this_.$http.get('SuratJalanDeliverySubcon/printdc/' + item.id)
            // .then(async function(response){
            //     if (response.data) {
			// 		this_.isBusy = false;
			// 		this_.toast({message: 'Print DC Executed', title:'Print DC', variant : 'success'});
			// 		return true;
            //     }
			// 	this_.isBusy = false;
            //     return null;
            // })
            // .catch(function(error){
			// 	this_.isBusy = false;
            //     this_.$store.dispatch('addErrorMessageGlobal', error);
            //     throw error;
            // });
		},
		async printSuratJalan() {
			let this_ = this;
			this_.isBusy = true;
			return this_.$http.get('SuratJalanDeliverySubcon/printsuratjalan/' + this.modelId)
            .then(async function(response){
                if (response.data) {
					this_.isBusy = false;
					return this_.showPopupPDF(response.data.download)
                }
				this_.isBusy = false;
                return null;
            })
            .catch(function(error){
				this_.isBusy = false;
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getSuratJalanDeliverySubcon : async function(id) {
			this.isBusy = true;
			SuratJalanDeliverySubcon.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSuratJalanDeliverySubcon = true;
			this.filterSuratJalanDeliverySubcon.id = this.modelId;
			SuratJalanDeliverySubcon.downloadDataDetail(this, this.filterSuratJalanDeliverySubcon).then(result => {
				this.isDownloadSuratJalanDeliverySubcon = false;
			}).catch(error => { this.isDownloadSuratJalanDeliverySubcon = false; })
		},
		getSuratJalanDeliverySubconDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSuratJalanDeliverySubconDetail);
			if (this.modelId == null) return;
			filter.suratJalanDeliverySubconId = this.modelId;
			filter.draftMode = "0";
			if (this.sortBySuratJalanDeliverySubconDetail != null) {
				this.sortingBySuratJalanDeliverySubconDetail[this.sortBySuratJalanDeliverySubconDetail] = this.sortDescSuratJalanDeliverySubconDetail;
			}
			let currentPage = (this.currentSuratJalanDeliverySubconDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSuratJalanDeliverySubconDetailRow + 1;
				let page = Math.ceil(totalData/this.suratJalanDeliverySubconDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.suratJalanDeliverySubconDetailPageSize = 0;
			// disable paging end
			SuratJalanDeliverySubconDetail.getList(this, filter, this.sortingBySuratJalanDeliverySubconDetail, currentPage , this.suratJalanDeliverySubconDetailPageSize).then(result => {
				this.currentSuratJalanDeliverySubconDetailPage = currentPage + 1;
				this.suratJalanDeliverySubconDetails = result.data;
				this.totalSuratJalanDeliverySubconDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSuratJalanDeliverySubcons : async function(input) {
			let filter = new SuratJalanDeliverySubconFilter();
			if (input != undefined) {
				filter.SuratJalanNumber = input;
			}
			this.isSuratJalanDeliverySubconComboLoading = true;
			SuratJalanDeliverySubcon.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.suratJalanDeliverySubcons = result.data
				}
				this.isSuratJalanDeliverySubconComboLoading = false;
			})
			.catch(error => {});
		},
		getSuratJalanDeliverySubcons : async function(input) {
			let filter = new SuratJalanDeliverySubconFilter();
			if (input != undefined) {
				filter.suratJalanNumber = input;
			}
			this.isSuratJalanDeliverySubconComboLoading = true;
			SuratJalanDeliverySubcon.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.suratJalanDeliverySubcons = result.data
				}
				this.isSuratJalanDeliverySubconComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionSubcontractDetails : async function(input) {
			let filter = new DeliveryInstructionSubcontractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionSubcontractDetailComboLoading = true;
			DeliveryInstructionSubcontractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontractDetails = result.data
				}
				this.isDeliveryInstructionSubcontractDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionSubcontracts : async function(input) {
			let filter = new DeliveryInstructionSubcontractFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			DeliveryInstructionSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontracts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstructionSubconExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.deliveryInstructionSubconId = null;
				this.model.deliveryInstructionSubcon = null;
				this.isBusy = true;
				SuratJalanDeliverySubcon.resetDocument(this, this.model.id).then(result => {
					this.getSuratJalanDeliverySubcon(this.model.id).then(result => {
						this.getSuratJalanDeliverySubconDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.deliveryInstructionSubconId = item.id;
				this.model.deliveryInstructionSubcon = item;

				this.isBusy = true;
				SuratJalanDeliverySubcon.copyFromDocument(this, 'deliveryinstructionsubcontract', item.id, this.model.id).then(result => {
					this.getSuratJalanDeliverySubcon(this.model.id).then(result => {
						this.getSuratJalanDeliverySubconDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedDeliveryInstructionSubcon(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.deliveryInstructionSubconId == itemId) return;
			}

			if(this.suratJalanDeliverySubconDetails != null && this.suratJalanDeliverySubconDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Surat Jalan Delivery Subcon akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedDeliveryInstructionSubconExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedDeliveryInstructionSubconExecuted(item);
			}
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDestination(item) {
			if(item == undefined || item == null) {
				this.model.destinationId = null;
				this.model.destination = null;
			} else {
				this.model.destinationId = item.id;
				this.model.destination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.suratJalanDeliverySubconInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					SuratJalanDeliverySubcon.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'suratjalandeliverysubconindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					SuratJalanDeliverySubcon.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'suratjalandeliverysubconindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SuratJalanDeliverySubcon.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getSuratJalanDeliverySubcon(id);
					});
				}
			});
		},
		onHidden() {
			this.getSuratJalanDeliverySubcons();
		},
		addRowDataSuratJalanDeliverySubconDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.suratJalanDeliverySubconId =  this.modelId;
					SuratJalanDeliverySubconDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSuratJalanDeliverySubconDetails(true);
						this.isShowPopupSuratJalanDeliverySubconDetail = false;
					})
				} else {
					model.suratJalanDeliverySubconId =  this.modelId;
					SuratJalanDeliverySubconDetail.createDataDetail(this, model)
					.then(result => {
						this.getSuratJalanDeliverySubconDetails(true);
						this.isShowPopupSuratJalanDeliverySubconDetail = false;
					})
				}
			}
		},
		async editRowDataSuratJalanDeliverySubconDetail(id) {
			this.suratJalanDeliverySubconDetailId = id;
			this.isShowPopupSuratJalanDeliverySubconDetail = true; 
		},
		async deleteRowDataSuratJalanDeliverySubconDetail(id) {
			SuratJalanDeliverySubconDetail.deleteData(this, id).then(result => { this.getSuratJalanDeliverySubconDetails(); });
		},
		async resetDataSuratJalanDeliverySubconDetail() {
			this.suratJalanDeliverySubconDetailId = "";
			this.isShowPopupSuratJalanDeliverySubconDetail = true;
		},
		async addDataSuratJalanDeliverySubconDetail() {
			SuratJalanDeliverySubconDetail.createData(this, { suratJalanDeliverySubconId: this.modelId })
			.then(result => {
				this.getSuratJalanDeliverySubconDetails(true);
			})
		},
		async addFromClipboardSuratJalanDeliverySubconDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, suratJalanDeliverySubconId: this.modelId });
				});
				SuratJalanDeliverySubconDetail.addFromClipboard(this, parts).then(result => { this.getSuratJalanDeliverySubconDetails() });
			});
		},
		async replaceFromClipboardSuratJalanDeliverySubconDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, suratJalanDeliverySubconId: this.modelId });
				});
				SuratJalanDeliverySubconDetail.replaceFromClipboard(this, parts).then(result => { this.getSuratJalanDeliverySubconDetails() });
			});   
		},
		showPopupUploadSuratJalanDeliverySubconDetail() {
			if(this.suratJalanDeliverySubconDetails != null && this.suratJalanDeliverySubconDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap SuratJalanDeliverySubconDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadSuratJalanDeliverySubconDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadSuratJalanDeliverySubconDetail = true;
			}
		},
		uploadDataSuratJalanDeliverySubconDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSuratJalanDeliverySubconDetail = false; 
		},
		downloadSuratJalanDeliverySubconDetail(modalEvent) {
			this.isDownloadSuratJalanDeliverySubconDetail = true;
			this.filterSuratJalanDeliverySubconDetail.suratJalanDeliverySubconId = this.modelId;
			SuratJalanDeliverySubconDetail.downloadDataDetail(this, this.filterSuratJalanDeliverySubconDetail).then(result => {
				this.isDownloadSuratJalanDeliverySubconDetail = false;
			}).catch(error => { this.isDownloadSuratJalanDeliverySubconDetail = false; })
		},
		saveInputSuratJalanDeliverySubconDetail(item) {
			if (this.suratJalanDeliverySubcons != null && this.suratJalanDeliverySubcons != undefined  && this.suratJalanDeliverySubcons.length > 0) {
				item.suratJalanDeliverySubcon = this.suratJalanDeliverySubcons.find(q => q.id == item.suratJalanDeliverySubconId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.deliveryInstructionSubcontractDetails != null && this.deliveryInstructionSubcontractDetails != undefined  && this.deliveryInstructionSubcontractDetails.length > 0) {
				item.deliveryInstructionSubconDetail = this.deliveryInstructionSubcontractDetails.find(q => q.id == item.deliveryInstructionSubconDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SuratJalanDeliverySubconDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadSuratJalanDeliverySubconDetail = false; 
			this.isShowPopupSuratJalanDeliverySubconDetail = false; 
			this.isShowPopupPDF = false;
			if (modalType == 'SuratJalanDeliverySubconDetail') {
				this.getSuratJalanDeliverySubconDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowSuratJalanDeliverySubconDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterSuratJalanDeliverySubcon = new SuratJalanDeliverySubconFilter();
		this.filterSuratJalanDeliverySubconDetail = new SuratJalanDeliverySubconDetailFilter();
		//this.getSuratJalanDeliverySubcons();
		//this.getParts();
		//this.getDeliveryInstructionSubcontractDetails();
		//this.getDeliveryInstructionSubcontracts();
		//this.getCustomers();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getSuratJalanDeliverySubcon(id);
			} else {
				this.modelId = id;
				this.getSuratJalanDeliverySubcon(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortBySuratJalanDeliverySubconDetail : {
			handler: function() {
				this.getSuratJalanDeliverySubconDetails();
			}
		},
		sortDescSuratJalanDeliverySubconDetail: {
			handler: function() {
				this.getSuratJalanDeliverySubconDetails();
			}
		},
		currentSuratJalanDeliverySubconDetailPage: {
			handler: function() {
				this.getSuratJalanDeliverySubconDetails();
			}
		},
		suratJalanDeliverySubconDetailPageSize : {
			handler: function() {
				this.getSuratJalanDeliverySubconDetails();
			}
		},
		filterSuratJalanDeliverySubconDetail: {
			handler: function() {
				this.getSuratJalanDeliverySubconDetails();
			},
			deep: true,
		},
	},
}
</script>
